// extracted by mini-css-extract-plugin
module.exports = {"root":"IconButtonWrapper_root__1wDqb"};